import { useState } from 'react';

/**
 * Custom hook for managing modal states
 * Handles all modal open/close states and related data
 */
export function useModals() {
    // Feature mapping modal state
    const [isMappingFeatureModalOpen, setIsMappingFeatureModalOpen] = useState(false);
    const [mappingFeatureType, setMappingFeatureType] = useState('link'); // 'link' or 'create'
    const [newFeatureName, setNewFeatureName] = useState('');
    const [selectedFeatureToLink, setSelectedFeatureToLink] = useState('');
    const [mappingSaving, setMappingSaving] = useState(false);

    // Share family with project
    const [shareFamily, setShareFamily] = useState(null);
    const [isLinkFamilyOpen, setIsLinkFamilyOpen] = useState(false);

    // Delete Family states
    const [isDeletingFamily, setIsDeletingFamily] = useState(false);
    const [deleteRuleSetsCheck, setDeleteRuleSetsCheck] = useState(false);
    const [deletingFamilyId, setDeletingFamilyId] = useState(null);

    // Change details modal states
    const [activeLogDetails, setActiveLogDetails] = useState(null);
    const [loadingLogDiff, setLoadingLogDiff] = useState(false);
    const [logDiffEntry, setLogDiffEntry] = useState(null);
    const [logRulesetData, setLogRulesetData] = useState(null);

    return {
        isMappingFeatureModalOpen,
        setIsMappingFeatureModalOpen,
        mappingFeatureType,
        setMappingFeatureType,
        newFeatureName,
        setNewFeatureName,
        selectedFeatureToLink,
        setSelectedFeatureToLink,
        mappingSaving,
        setMappingSaving,
        shareFamily,
        setShareFamily,
        isLinkFamilyOpen,
        setIsLinkFamilyOpen,
        isDeletingFamily,
        setIsDeletingFamily,
        deleteRuleSetsCheck,
        setDeleteRuleSetsCheck,
        deletingFamilyId,
        setDeletingFamilyId,
        activeLogDetails,
        setActiveLogDetails,
        loadingLogDiff,
        setLoadingLogDiff,
        logDiffEntry,
        setLogDiffEntry,
        logRulesetData,
        setLogRulesetData
    };
}
